import moment from 'moment';

export const addCapitalAccount = (obj, date) => ({
    id: obj.id,
    shareSubcategory: obj.shareSubcategory,
    vl: +obj.vl,
    date: moment(date).format('YYYY-MM-DD'),
});
